var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown flex items-center"},[_c('img',{staticClass:"img",attrs:{"src":require("@/render/assets/images/clock.png")}}),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }